import { render, staticRenderFns } from "./ArrayCheckbox.vue?vue&type=template&id=bec21698&scoped=true&"
import script from "./ArrayCheckbox.vue?vue&type=script&lang=js&"
export * from "./ArrayCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec21698",
  null
  
)

export default component.exports